export function formatPrice(price){
    return `${price.amount} ${price.currencyCode}`
}